(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.easing = mod.exports;
  }
})(this, function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  // import BezierEasing from 'bezier-easing';
  // copy from https://github.com/gdsmith/jquery.easing/blob/master/jquery.easing.js
  // easing函数参数
  var pow = Math.pow,
      sqrt = Math.sqrt,
      sin = Math.sin,
      cos = Math.cos,
      PI = Math.PI,
      c1 = 1.70158,
      c2 = c1 * 1.525,
      c3 = c1 + 1,
      c4 = 2 * PI / 3,
      c5 = 2 * PI / 4.5;

  var bounceOut = exports.bounceOut = function bounceOut(x) {
    var n1 = 7.5625,
        d1 = 2.75;
    if (x < 1 / d1) {
      return n1 * x * x;
    } else if (x < 2 / d1) {
      return n1 * (x -= 1.5 / d1) * x + 0.75;
    } else if (x < 2.5 / d1) {
      return n1 * (x -= 2.25 / d1) * x + 0.9375;
    } else {
      return n1 * (x -= 2.625 / d1) * x + 0.984375;
    }
  };

  var easeInQuad = exports.easeInQuad = function easeInQuad(x) {
    return x * x;
  };
  var easeOutQuad = exports.easeOutQuad = function easeOutQuad(x) {
    return 1 - (1 - x) * (1 - x);
  };
  var easeInOutQuad = exports.easeInOutQuad = function easeInOutQuad(x) {
    return x < 0.5 ? 2 * x * x : 1 - pow(-2 * x + 2, 2) / 2;
  };
  var easeInCubic = exports.easeInCubic = function easeInCubic(x) {
    return x * x * x;
  };
  var easeOutCubic = exports.easeOutCubic = function easeOutCubic(x) {
    return 1 - pow(1 - x, 3);
  };
  var easeInOutCubic = exports.easeInOutCubic = function easeInOutCubic(x) {
    return x < 0.5 ? 4 * x * x * x : 1 - pow(-2 * x + 2, 3) / 2;
  };
  var easeInQuart = exports.easeInQuart = function easeInQuart(x) {
    return x * x * x * x;
  };
  var easeOutQuart = exports.easeOutQuart = function easeOutQuart(x) {
    return 1 - pow(1 - x, 4);
  };
  var easeInOutQuart = exports.easeInOutQuart = function easeInOutQuart(x) {
    return x < 0.5 ? 8 * x * x * x * x : 1 - pow(-2 * x + 2, 4) / 2;
  };
  var easeInQuint = exports.easeInQuint = function easeInQuint(x) {
    return x * x * x * x * x;
  };
  var easeOutQuint = exports.easeOutQuint = function easeOutQuint(x) {
    return 1 - pow(1 - x, 5);
  };
  var easeInOutQuint = exports.easeInOutQuint = function easeInOutQuint(x) {
    return x < 0.5 ? 16 * x * x * x * x * x : 1 - pow(-2 * x + 2, 5) / 2;
  };
  var easeInSine = exports.easeInSine = function easeInSine(x) {
    return 1 - cos(x * PI / 2);
  };
  // swiper 横滑使用该函数
  var easeOutSine = exports.easeOutSine = function easeOutSine(x) {
    return sin(x * PI / 2);
  };
  var easeInOutSine = exports.easeInOutSine = function easeInOutSine(x) {
    return -(cos(PI * x) - 1) / 2;
  };
  var easeInExpo = exports.easeInExpo = function easeInExpo(x) {
    return x === 0 ? 0 : pow(2, 10 * x - 10);
  };
  var easeOutExpo = exports.easeOutExpo = function easeOutExpo(x) {
    return x === 1 ? 1 : 1 - pow(2, -10 * x);
  };
  var easeInOutExpo = exports.easeInOutExpo = function easeInOutExpo(x) {
    return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? pow(2, 20 * x - 10) / 2 : (2 - pow(2, -20 * x + 10)) / 2;
  };
  var easeInCirc = exports.easeInCirc = function easeInCirc(x) {
    return 1 - sqrt(1 - pow(x, 2));
  };
  var easeOutCirc = exports.easeOutCirc = function easeOutCirc(x) {
    return sqrt(1 - pow(x - 1, 2));
  };
  var easeInOutCirc = exports.easeInOutCirc = function easeInOutCirc(x) {
    return x < 0.5 ? (1 - sqrt(1 - pow(2 * x, 2))) / 2 : (sqrt(1 - pow(-2 * x + 2, 2)) + 1) / 2;
  };
  var easeInElastic = exports.easeInElastic = function easeInElastic(x) {
    return x === 0 ? 0 : x === 1 ? 1 : -pow(2, 10 * x - 10) * sin((x * 10 - 10.75) * c4);
  };
  var easeOutElastic = exports.easeOutElastic = function easeOutElastic(x) {
    return x === 0 ? 0 : x === 1 ? 1 : pow(2, -10 * x) * sin((x * 10 - 0.75) * c4) + 1;
  };
  var easeInOutElastic = exports.easeInOutElastic = function easeInOutElastic(x) {
    return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(pow(2, 20 * x - 10) * sin((20 * x - 11.125) * c5)) / 2 : pow(2, -20 * x + 10) * sin((20 * x - 11.125) * c5) / 2 + 1;
  };
  var easeInBack = exports.easeInBack = function easeInBack(x) {
    return c3 * x * x * x - c1 * x * x;
  };
  var easeOutBack = exports.easeOutBack = function easeOutBack(x) {
    return 1 + c3 * pow(x - 1, 3) + c1 * pow(x - 1, 2);
  };
  var easeInOutBack = exports.easeInOutBack = function easeInOutBack(x) {
    return x < 0.5 ? pow(2 * x, 2) * ((c2 + 1) * 2 * x - c2) / 2 : (pow(2 * x - 2, 2) * ((c2 + 1) * (x * 2 - 2) + c2) + 2) / 2;
  };
  var easeInBounce = exports.easeInBounce = function easeInBounce(x) {
    return 1 - bounceOut(1 - x);
  };
  var easeOutBounce = exports.easeOutBounce = bounceOut;
  var easeInOutBounce = exports.easeInOutBounce = function easeInOutBounce(x) {
    return x < 0.5 ? (1 - bounceOut(1 - 2 * x)) / 2 : (1 + bounceOut(2 * x - 1)) / 2;
  };
});